import Head from 'next/head';
import { Maybe, Page } from '@/graphql/__generated/sdk';
import { useAppContext } from '@shared-components/context';
export function NextPageHeadSchemaWebpage({
  title,
  description,
  breadcrumbs,
  breadcrumbTitle,
  originUrl,
  path
}: Readonly<{
  breadcrumbs?: Maybe<Maybe<Page>[]>;
  breadcrumbTitle: Maybe<Page['breadcrumbTitle']>;
  originUrl: string;
  title: Maybe<Page['title']>;
  description: Maybe<Page['description']>;
  path?: Maybe<Page['path']>;
}>) {
  const {
    config
  } = useAppContext();
  const {
    schema
  } = config.features;
  const currentPageUrl = `${originUrl}${path ?? ''}`;
  const breadcrumbItems = (breadcrumbs || [])?.filter((item): item is Page => !!item).map((breadcrumb, index) => ({
    position: index + 1,
    '@type': 'ListItem',
    item: {
      '@id': `${originUrl}${breadcrumb.path ?? ''}`,
      name: breadcrumb?.breadcrumbTitle || ''
    }
  }));
  const breadcrumbItemsSchema = breadcrumbItems.concat([{
    position: breadcrumbItems.length + 1,
    '@type': 'ListItem',
    item: {
      '@id': currentPageUrl,
      name: breadcrumbTitle || ''
    }
  }]);
  return <Head data-sentry-element="Head" data-sentry-component="NextPageHeadSchemaWebpage" data-sentry-source-file="NextPageHeadSchemaWebpage.tsx">
			<script type="application/ld+json" id="webpage-schema" dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: title || '',
        url: currentPageUrl,
        description: description || '',
        ...schema,
        ...(breadcrumbs?.length && {
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbItemsSchema
          }
        })
      })
    }} />
		</Head>;
}